<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="importAction" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-is-valid="!isFile" :vm-active="isModalImportRestrictionsVisible" :vm-title='title')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          input(type="file" id="file" ref="file" v-on:change="handleFileUpload()" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .xls, .xlsx")
        span
          slot Descarga una
          a(@click="downloadRestrictionsTemplate({model})") &nbsp;plantilla de CSV de muestra
          slot &nbsp;para ver un ejemplo del formato requerido.
</template>

<script>
import { } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Pos')
const XlsxPopulate = require('xlsx-populate')

export default {
  name: 'ModalImportRestrictions',
  props: {
    title: {
      type: String,
      default: 'Import CSV or Excel file'
    },
    model: {
      type: String
    }
  },
  data () {
    return {
      file: '',
      data: []
    }
  },
  computed: {
    ...mapGetters([
      'isModalImportRestrictionsVisible'
    ]),
    isFile () {
      return !this.file
    }
  },
  methods: {
    ...mapActions([
      'importDataRestrictions',
      'downloadRestrictionsTemplate',
      'setModalImportRestrictionsVisible'
    ]),
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
      XlsxPopulate.fromDataAsync(this.file)
        .then(workbook => {
          this.data = workbook.sheet('Sheet1').usedRange().value()
          this.data = this.data.slice(1).filter((e, index) => {
            return parseFloat(e[2]) !== 0 && !isNaN(parseFloat(e[2]))
          }).map((el, index) => {
            return {
              id: el[0],
              product: el[1],
              restriction: el[2]
            }
          })
          console.log(this.data)
        })
    },
    importAction () {
      this.importDataRestrictions(this.data)
    },
    close () {
      this.setModalImportRestrictionsVisible(false)
    }
  }
}
</script>

<style>
.vm-select--options {
  z-index: 400331 !important;
}
a {
  cursor: pointer;
}
</style>
